<template>
    <div v-loading="loading" class="container-fluid mt-6 px-5">
        <soft-button color="secondary" @click="goBack">
            <i class="fa fa-arrow-left"></i>&nbsp;Geri
        </soft-button>
        <div class="card mt-4">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <soft-button color="dark" size="small" @click="openPrintDialog">
                        <i class="fa-solid fa-print"></i>&nbsp;Çap forması
                    </soft-button>
                </div>
                <hr style="margin-top:0;" />
                <div class="d-flex justify-content-between align-items-start mb-2">
                    <titles text="Nəticə" />
                    <div class="d-flex align-items-center">
                        <div v-if="executorMeta.createdBy || executorMeta.updatedBy" class="record-label-wrapper me-3">
                            <button type="button" class="btn btn-sm bg-white shadow-none p-0 mb-0">
                                <i class="fa-solid fa-info-circle text-muted fs-5 ms-2"></i>
                            </button>
                            <div class="record-label-tooltip">
                                <record-label :created="executorMeta.createdBy" :updated="executorMeta.updatedBy"
                                    style="color: #606266; font-size: 14px" />
                            </div>
                        </div>
                        <soft-button type="button" class="btn btn-sm bg-white shadow-none p-0" title="Düzəliş et"
                            @click="openEditDialog">
                            <i class="fa-regular fa-edit text-muted fs-5"></i>
                        </soft-button>
                    </div>
                </div>
                <hr style="margin-top: 10px" />
                <div class="row" style="color: #606266; font-size: 14px">
                    <div class="col-6 mb-2">
                        <div class="row">
                            <div class="col-4 font-weight-bold">Məktub göndərildi:</div>
                            <div class="col-8">{{ letterSent ? formatDate(letterSentDate) : '-' }}</div>
                        </div>
                    </div>
                    <div class="col-6 mb-2">
                        <div class="row">
                            <div class="col-4 font-weight-bold">Məktubun nəticəsi:</div>
                            <div class="col-8">
                                {{
                                    letterResult === 1
                                        ? 'Razılıq əldə olundu'
                                        : letterResult === 2
                                            ? 'Məhkəməyə göndərilsin'
                                : '-'
                                }}
                            </div>
                        </div>
                    </div>
                </div>

                <el-dialog v-model="printDialogVisible" width="60%" top="3vh" center>
                    <div id="printMe1" ref="printMeRef1">
                        <div class="d-flex mb-3">
                            <soft-button id="printButton" v-print="'#printMe1'" color="dark">
                                <i class="fa-solid fa-print"></i>&nbsp;Çap et
                            </soft-button>
                            <soft-button v-if="!letterSent" id="sendButton" color="light" class="ms-2"
                                @click="sendLetter">
                                <i class="fa-solid fa-paper-plane"></i>&nbsp;Məktubu göndər
                            </soft-button>
                        </div>
                        <demand-letter :subrogation-id="subrogationId" :participant-id="participantId" />
                    </div>
                </el-dialog>

                <el-dialog v-model="editDialogVisible" title="Məktubun nəticəsi" width="30%" top="200px">
                    <el-select v-model="tempLetterResult" size="large" placeholder="Seçin" style="width: 100%">
                        <el-option label="Razılıq əldə olundu" :value="1" />
                        <el-option label="Məhkəməyə göndərilsin" :value="2" />
                    </el-select>
                    <div class="d-flex justify-content-end mt-4">
                        <soft-button @click="saveLetterResult">Yadda saxla</soft-button>
                        <soft-button color="secondary" class="ms-2"
                            @click="editDialogVisible = false">İmtina</soft-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import SoftButton from '@/components/SoftButton.vue';
import Titles from '@/project/Components/Titles.vue';
import RecordLabel from '@/project/Components/RecordLabel.vue';
import DemandLetter from '@/project/Components/DemandLetter.vue';
import {
    GetCourtPreparation,
    CreateCourtPreparation,
    UpdateCourtPreparation,
} from '@/project/Source/courtpreparations';


export default {
    name: 'CourtPreparationForm',
    components: {
        SoftButton,
        Titles,
        RecordLabel,
        DemandLetter,
    },
    props: {
        subrogationId: {
            type: [String, Number],
            required: true,
        },
        participantId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            printDialogVisible: false,
            letterSent: false,
            letterSentDate: null,
            editDialogVisible: false,
            letterResult: null,
            tempLetterResult: null,
            executorMeta: {
                createdBy: null,
                updatedBy: null,
            },
        };
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        goBack() {
            window.history.back();
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            const d = new Date(dateString);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
        },
        async loadData() {
            this.loading = true;
            try {
                const resp = await GetCourtPreparation(this.subrogationId, this.participantId);
                const d = resp.data || {};
                this.letterSentDate = d.letterSentDate || null;
                this.letterSent = !!this.letterSentDate;
                this.letterResult = d.letterResult || null;
                this.executorMeta = {
                    createdBy: d.createdBy || null,
                    updatedBy: d.updatedBy || null,
                };
            } catch (e) {
                console.error('Error loading court preparation:', e);
            } finally {
                this.loading = false;
            }
        },
        openPrintDialog() {
            this.printDialogVisible = true;
        },
        async sendLetter() {
            this.loading = true;
            try {
                await CreateCourtPreparation({
                    subrogationId: this.subrogationId,
                    participantId: this.participantId,
                    user: this.$store.state.user.id,
                });
                await this.loadData();
                this.$message.success('Məktub göndərildi');
                this.printDialogVisible = false;
            } catch (e) {
                console.error('Error sending letter:', e);
            } finally {
                this.loading = false;
            }
        },
        openEditDialog() {
            this.tempLetterResult = this.letterResult;
            this.editDialogVisible = true;
        },
        async saveLetterResult() {
            if (!this.tempLetterResult) {
                return this.$message.warning('Seçin');
            }
            this.loading = true;
            try {
                await UpdateCourtPreparation({
                    subrogationId: this.subrogationId,
                    participantId: this.participantId,
                    letterResult: this.tempLetterResult,
                    user: this.$store.state.user.id,
                });
                this.letterResult = this.tempLetterResult;
                this.$message.success('Nəticə yadda saxlanıldı');
            } catch (e) {
                console.error('Error saving letter result:', e);
                this.$message.error('Xəta baş verdi');
            } finally {
                this.loading = false;
                this.editDialogVisible = false;
            }
        },
    },
};
</script>

<style scoped>
.record-label-wrapper {
    position: relative;
}

.record-label-tooltip {
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    z-index: 1000;
    min-width: 180px;
    opacity: 0;
    transform: translateY(5px);
    pointer-events: none;
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.record-label-wrapper:hover .record-label-tooltip {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
}

@media print {

    #printButton,
    #sendButton {
        display: none !important;
    }
}
</style>